import React from 'react'
import ModalCambioPass from './modales/ModalCambioPass'
import { useNavigate } from 'react-router-dom';

const ValidarUsuario = () => {
	const navigate = useNavigate();

	return (
		<ModalCambioPass
			show={true}
			onHide={() => {navigate("/");}}
			validar={true} //para validar usuario, si no es para cambiar
		/>
	)
}

export default ValidarUsuario